import { GridCellParams } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";

export const scheduledInvoicesOptions = {
    dataGridOptions: {
        extraColumns: {
            beggining: [
                {
                    headerName: "Ver Compra",
                    field: "view_order",
                    width: 120,
                    renderCell: (params: GridCellParams) => {
                        const orderId = params.row?.order?.id;
      

                        if (!orderId) return null;

                        return (
                            <IconButton
                                sx={{ p: 0 }}
                                onClick={(e) => e.stopPropagation()}
                                color="secondary"
                                component={Link}
                                to={`/orders/${orderId}/detail`}
                                target="_blank"
                            >
                                <OpenInNew />
                            </IconButton>
                        );
                    },
                },
            ],
        },
    },
};

